import $ from './el.JsModules.js';

const SELECTOR = {
  TEMPLATE: '#el-video-launcher-overlay-template',
  OVERLAY: '.js-video-launcher-overlay',
  IFRAME: '.js-video-launcher-iframe',
  CLOSE_BTN: '.js-video-launcher-close',
  TOGGLE_SOUND_BTN: '.js-video-launcher-toggle-sound',
  SOUND_STATUS_BTN: '.js-sound-status',
  CAPTION: '.js-video-launcher-caption',
};

elabs.VideoLauncherOverlay = class {
  'use strict';

  constructor(element) {
    const hash = window.location.hash;

    //ELEMENTS
    this.view = $(element);
    this.templateElement = this.view.find(SELECTOR.TEMPLATE)[0];
    this.overlay = null;
    this.iframe = null;
    this.closeBtn = null;
    this.toggleSound = null;
    this.captionElement = null;
    this.soundStatus = null;

    //STATE
    this.player = null;
    this.inited = false;
    this.videoData = null;
    this.muted = true;
    this.currentVideoId = null;

    //LAUNCH VIDEO BY HASH
    if (hash.includes('video')) {
      const videoData = this.getDataFromHashParams(window.location.toString());
      this.videoData = videoData;

      this.appendTemplate();
      this.launchVideo(videoData);
    }

    //LAUNCH VIDEO BY CLICK
    $(document).on('click', 'a[href*="#video"]', (e) => {
      e.preventDefault();

      const videoData = this.getDataFromHashParams(e.target.href);
      this.videoData = videoData;

      this.appendTemplate();
      this.launchVideo(videoData);
    });
  }

  async loadVimeoJavascriptApi() {
    if (elabs.VideoLauncherOverlay.inited) return;

    elabs.VideoLauncherOverlay.inited = true;
    const vimeoApiUrl = 'https://player.vimeo.com/api/player.js';
    const script = document.createElement('script');
    script.src = vimeoApiUrl;
    script.async = true;
    document.body.appendChild(script);

    return new Promise((resolve) => {
      script.onload = () => {
        resolve();
      };
    });
  }

  async launchVideo(videoData) {
    await this.loadVimeoJavascriptApi();

    if (typeof elabs.VideoLauncherOverlay.canAudioBePlayedWithoutUserInteraction === 'undefined') {
      if (typeof AudioContext !== 'undefined') {
        const audioContext = new AudioContext();
        elabs.VideoLauncherOverlay.canAudioBePlayedWithoutUserInteraction = audioContext.state === 'running';
      }
    }

    const isMobile = $(window).width() < 500;
    const videoId = isMobile ? videoData.mobileVideoId : videoData.desktopVideoId;

    if (this.currentVideoId === videoId) return;

    this.currentVideoId = videoId;
    const mutedArg = elabs.VideoLauncherOverlay.canAudioBePlayedWithoutUserInteraction ? '' : '&muted=1';
    const videoSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&title=0&byline=0&portrait=0&playsinline=1&color=404d5b${mutedArg}`;
    this.iframe.attr('src', videoSrc);

    this.iframe.on('load', async () => {
      try {
        if (this.player) {
          this.player.off('volumechange');
        }

        this.player = new Vimeo.Player(this.iframe[0]);

        // Listen for volume/mute changes
        this.player.on('volumechange', async () => {
          const muted = await this.player.getMuted();
          this.muted = muted;
          this.updateSoundStatus(muted);
        });

        await this.player.ready();

        const muted = await this.player.getMuted();
        this.muted = muted;
        this.updateSoundStatus(muted);
      } catch (err) {
        console.warn('Vimeo Player init failed:', err);
      }
    });
  }

  showOverlay() {
    history.replaceState(null, '', location.pathname);
    if (this.videoData.caption) {
      this.captionElement.html(this.videoData.caption).show();
    } else {
      this.captionElement.hide();
    }
    this.overlay.addClass('active');
    $('body').addClass('overflow-hidden');
  }

  async closeOverlay() {
    history.replaceState(null, '', location.pathname);
    this.overlay.removeClass('active');
    $('body').removeClass('overflow-hidden');
    this.view.html('');
    this.currentVideoId = null;
  }

  async toggleSoundState() {
    const muted = await this.player.getMuted();

    if (muted) {
      await this.player.setVolume(1);
    } else {
      await this.player.setVolume(0);
    }
  }

  updateSoundStatus(muted) {
    this.soundStatus.text(muted ? 'Sound On' : 'Sound Off');
  }

  getDataFromHashParams(urlString) {
    const url = new URL(urlString);
    const hashParams = new URLSearchParams(url.hash.split('?')[1] || '');
    const mobileVideoId = hashParams.get('mobile');
    const desktopVideoId = hashParams.get('desktop');
    const caption = hashParams.get('caption');

    return {
      mobileVideoId,
      desktopVideoId,
      caption,
    };
  }

  appendTemplate() {
    //RESET PREV CONTENT
    this.view.html('');

    this.view.append($(this.templateElement.content.cloneNode(true)));
    this.overlay = this.view.find(SELECTOR.OVERLAY);
    this.iframe = this.view.find(SELECTOR.IFRAME);
    this.closeBtn = this.view.find(SELECTOR.CLOSE_BTN);
    this.toggleSound = this.view.find(SELECTOR.TOGGLE_SOUND_BTN);
    this.captionElement = this.view.find(SELECTOR.CAPTION);
    this.soundStatus = this.view.find(SELECTOR.SOUND_STATUS_BTN);

    this.overlay.show();
    this.showOverlay();
    this.bindEvents();
  }

  bindEvents() {
    this.closeBtn.on('click', this.closeOverlay.bind(this));
    this.toggleSound.on('click', this.toggleSoundState.bind(this));
    elabs.documentElement.on('WINDOW_RESIZED_EVENT', this.handleResize.bind(this));
  }

  handleResize() {
    if (!this.overlay.hasClass('active')) return;
    this.launchVideo(this.videoData);
  }
};

elabs.onJavascriptReady(() => {
  new elabs.VideoLauncherOverlay($('#el-video-launcher-overlay'));
});
